import type { FluidProp } from '@twist/core';

/**
 * A helper function that simplifies generation of fluid value input ranges.
 * It takes in values expected at our mockup viewports (480px on mobile a
 * nd 1440px on desktop) and generates a twist fluid property input array
 * for them.
 *
 * @example
 * toFluidVarInput(16, 22)
 *
 * // will return [
 * //  ['min', 16],
 * //  ['sm', 'lg', 16, 32],
 * //  ['lg', 'max', 14.66, 29.32],
 * //  ['max', 29.32]
 * // ]
 */
export function toFluidVarInput(valueAtMobile: number, valueAtDesktop: number): FluidProp {
  const desktopRangeStart = (valueAtDesktop * 2) / 3;
  const desktopRangeEnd = desktopRangeStart * 2;

  return [
    ['min', valueAtMobile],
    ['sm', 'lg', valueAtMobile, valueAtMobile * 2],
    ['lg', 'max', desktopRangeStart, desktopRangeEnd],
    ['max', desktopRangeEnd]
  ];
}
